import { styled } from "@mui/material";
import ComboBoxField from "controls/global/combo-box-field/ComboBoxInputField";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";
import { uniqBy } from "lodash";
import { useSignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import React, {
  useEffect,
  useState,
} from "react";
import { useFormContext } from "react-hook-form";
import { margin } from "theme/defaultStyle";
import { useAgencyLocationByImage  } from "utils/context/SignatureDefaultsContext";

const FormField = styled("div")({
  marginTop: margin.xlarge1,
});

const FIELD_NAME = "agency";

const AgencyField = React.memo(function AgencyField() {
  const [availableAgencies, setAvailableAgencies] = useState<SelectFieldOption[]>([]);
  const [{ agencyLocationsByImage }] = useAgencyLocationByImage(); // useSignatureDefaults(); 
  const { setValue, getValues } = useFormContext();
  const { mode, setUserInteracted } = useSignatureDefaultDialogProvider();

  const handleAgencyNameChange = (item: any) => {
    setUserInteracted();
    setValue(FIELD_NAME, item.value);
    if(mode === "ADD") {
      setValue("state", { text: "", value: "" });
      setValue("location", []);
    }
  };

  const handleOnBlur = (eventArgs: any) => {
    const selectedValue = eventArgs?.target?.value;
    if(!selectedValue) return;

    const matchingAgency = availableAgencies?.find((a) => a.text === selectedValue);
    if(!matchingAgency) { 
      setValue(FIELD_NAME, "All");
    }else {
      setValue(FIELD_NAME, matchingAgency.value);
    }
  };

  useEffect(() => {
    let agencies: SelectFieldOption[] = uniqBy(agencyLocationsByImage, a => a.agencyID).map((l) => ({
      value: l.agencyID,
      text: l.agencyName
    }));

    const showAll = agencies.length > 1;
    if (showAll) {
      agencies = [
        { text: "All My Agencies", value: "All" },
        ...agencies
      ];
    }

    setAvailableAgencies(agencies);

    const selectedAgency = getValues(FIELD_NAME);
    if (agencies.length > 0 && agencies.filter(l => l.value === selectedAgency).length === 0) {
      setValue(FIELD_NAME, agencies[0].value);
    }
  }, [agencyLocationsByImage]);

  // useEffect(() => {
  //   console.log("--RERENDER -> AgencyField.tsx");
  // })

  return (
    <FormField>
      <ComboBoxField
        label={"Agency Name"}
        options={availableAgencies}
        {...{ name: FIELD_NAME, disabled: availableAgencies.length < 1 }}
        onChange={(_: any, selectedValue: any) => {
          handleAgencyNameChange(selectedValue);
        }}
        roundedCorner={true}
        onBlur={handleOnBlur}
        freeSolo={true} 
        disabled={availableAgencies.length < 1}
        disableClearable={true}
      />
    </FormField>
  );
});

export default AgencyField;
